import {
  SAVE_PREFERENCES,
  REMOVE_PREFERENCES,
  UPDATE_PREFERENCES,
  SAVE_PREFERENCES_FAIL,
  DO_NOT_SET_PREFERENCE,
} from './preference/actions'

import { USER_LOGGED_IN, USER_LOGGED_OUT } from './../constants/user'

import { INIT_USER, UNSET_USER } from './actions'

const initialState = () => null

const user = (state = initialState(), action) => {
  switch (action.type) {
    case INIT_USER:
      return { ...action.payload }
    case UNSET_USER:
      return initialState()
    case USER_LOGGED_IN:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false
    };
    case USER_LOGGED_OUT:
      return null
    case SAVE_PREFERENCES: {
      const {
        value: { product_defaults },
      } = action

      return {
        ...state,
        isBusy: true,
        error: false,
        defaultPreference: product_defaults,
      }
    }
    case REMOVE_PREFERENCES: {
      return {
        ...state,
        defaultPreference: null,
      }
    }
    case UPDATE_PREFERENCES: {
      const {
        value: { product_defaults },
      } = action
      return {
        ...state,
        isBusy: false,
        error: false,
        defaultPreference: product_defaults,
      }
    }
    case SAVE_PREFERENCES_FAIL: {
      const {
        value: { product_defaults },
      } = action
      return {
        ...state,
        isBusy: false,
        error: true,
        defaultPreference: product_defaults,
      }
    }
    case DO_NOT_SET_PREFERENCE: {
      const {
        value: { product_defaults },
      } = action
      return {
        ...state,
        isBusy: false,
        error: false,
        defaultPreference: product_defaults,
      }
    }
    default:
      return state
  }
}

export default user
